import * as React from 'react';
import { IDonorStatus, IDonorRegistration, IListItem } from '@nkr/models/index';
import { ViewWrapper } from '../styles';
import ViewPreWorkUpData from './view-pre-workup-data';
import { IDashRemoteStatus } from '@nkr/models/donor-status-by-center';


interface IProps {
    centerId: number,
    data: IDonorRegistration,
    dataList: IDonorRegistration[],
    statusList: IDonorStatus[],
    remoteStatusList: IDashRemoteStatus[],
    stateList: IListItem[],
    actionList: IListItem[],
    dispositionList: IListItem[],
    donationTypeList: IListItem[],
    ruleOutReasons?: Array<{ id: number; description: string }>,
    validation: {
        centerWorkFlowIdValid: boolean,
        centerNextFollowupDateValid: boolean
    },
    isMobile: boolean,
    messages: string[],
    onDataChange: (field: string, value: any) => void,
    updateDataStatus: ( registration : IDonorRegistration ) => void,
    updateComments: () => void,
    updateDisposition: () => void,
    onSave: () => void,
    onRuleOut?: (donorId: number, reasonId: number, allowReRegistration: boolean, useNkrAssistance: boolean, coordinatorName?: string, phoneNumber?: string, medicalReasonCategory?: number, medicalReasonNotes?: string) => void
}

interface IState { }

class ViewPreWorkUp extends React.Component<IProps, IState> {

    render = () => {
        const { dataList } = this.props;
        if (!this.props.isMobile) {
            return (
                <ViewWrapper>
                    <div className='modal-container'>
                        <ViewPreWorkUpData
                            centerId={this.props.centerId}
                            data={this.props.data}
                            statusList={this.props.statusList}
                            remoteStatusList={this.props.remoteStatusList}
                            stateList={this.props.stateList}
                            validation={this.props.validation}
                            messages={this.props.messages}
                            onDataChange={this.props.onDataChange}
                            onUpdateStatus={this.props.updateDataStatus}
                            onSave={this.props.onSave}
                            ruleOutReasons={this.props.ruleOutReasons}
                            onRuleOut={this.props.onRuleOut}
                        />
                    </div>
                </ViewWrapper>
            );
        } else {
            return (
                <div>
                    {dataList.map(d =>
                        <ViewPreWorkUpData
                            data={this.props.data}
                            centerId={this.props.centerId}
                            statusList={this.props.statusList}
                            remoteStatusList={this.props.remoteStatusList}
                            stateList={this.props.stateList}
                            validation={this.props.validation}
                            messages={this.props.messages}
                            onDataChange={this.props.onDataChange}
                            onUpdateStatus={this.props.updateDataStatus}
                            onSave={this.props.onSave}
                            ruleOutReasons={this.props.ruleOutReasons}
                            onRuleOut={this.props.onRuleOut}
                        />
                    )}
                </div>
            );
        }
    }
}

export default ViewPreWorkUp;